module.exports = __webpack_public_path__ + "static/media/bordnamona.b34e5ab1.png";